export interface Tag {
  name: string;
  url: string;
}

export enum FeedbackType {
  negative = 'negative',
  positive = 'positive',
}

export type Feedback = Record<FeedbackType, string>;

export interface Recommendation {
  id: string;
  cta: string;
  images: Array<string>;
  description: string;
  tags: Array<Tag>;
  relevance?: number;
}

export type Recommendations = Array<Recommendation>;

export interface RecommendationsGroup {
  id: string;
  description: string;
  recommendations: Recommendations;
  feedback: Feedback;
}
